import { render, staticRenderFns } from "./ProvisionalManualOrderEdit.vue?vue&type=template&id=2b32be16&lang=pug"
import script from "./ProvisionalManualOrderEdit.vue?vue&type=script&lang=js"
export * from "./ProvisionalManualOrderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports